const CaseNotificationEnum = {
    userNotification: {id: 1, title: "მომხარებელმა ატვირთა განაცხადი"},
    sentForVisage: {id: 2, title: "დასავიზირებლად გააგზავნა"},
    sentBack: {id: 3, title: "უკან დააბრუნა"},
    added: {id: 4, title: "დაამატა მომხმარებელი"},
    sentToAnotherDepartment: {id: 5, title: "სამსახუროებრივი ბარათის გაგზავნა"},
    answerFromDepartment: {id: 6, title: "სამსახურეობრივი ბარათის პასუხი"},
    createdByJobservice: {id: 7, title: "გენერერიებული პასუხი"},
    sentToApprove: {id: 8, title: "დაავიზა დოკუმენტი"},
    userSentDeclinedFile: {id: 9, title: "მომხმარებელმა ატვირთა დახარვეზებული დოკუმენტები"},
    newCaseExpert: {id: 10, title: "შიდა განაცხადის შექმნა"},
    createDocument: {id: 11, title: "დოკუმენტის შექმნა"},
    removeUser: {id: 12, title: "წაშალა მომხმარებელი"},
    addUser: {id: 13, title: "შეცვალა მომხმარებელი"},
    declinedFiled: {id: 14, title: "დაახარვეზა დოკუმენტი"},
    editedField: {id: 15, title: "ველის რედაქტირება"},
    userSentConditionalDocument: {id: 16, title: "მომხარებლემა ატვირთა პირობიანი დოკუმენტი"},
    conditionalDeadLineEnded: {id: 17, title: "პირობას გასდის ვადა"},
    createdFile: {id: 18, title: "შექმნა დოკუმენტი"},
    editedFile: {id: 19, title: "დაარედაქტირა დოკუმენტი"},
    visagedInternalFile: {id: 20, title: "დაავიზა შიდა დოკუმენტი"},
    userRequestedToCancelCase: {id: 21, title: "მომხმარებელმა შექმნა ნებართვის ძალადაკარგულად გამოცხადების მოთხოვნა"},
    headOfAgencyDeclinedCase: {id: 22, title: "დაახარვეზა განაცხადი"},
    mergedCase: {id: 23, title: "გააერთიანა განაცხადები"},
    movedCaseToObjectRegistery: {id: 24, title: "გადაიტანა ობიექტი უწყებტრივ რეესტრში"},
    visagedFile: {id: 25, title: "დაავიზირა დოკუმენტი"},
    deletedFile: {id: 26, title: "წაშალა დოკუმენტი"},
    postponeCaseDeclinationDaysRequest: {id: 27, title: "მოითხოვა დახარვეზების დღეების გახანგრძლივება"},
    requestToCancelCase: {id: 28, title: "განაცხადის განუხილველად დატოვების მოთხოვნა"},
    rewriteRequest: {id: 29, title: "მომხმარებელმა მოითხოვა განაცხადის გადაწერა"},
    headApprovedRewriteRequest: {id: 30, title: "დაადატურა განაცხადის გადაწერის მოთხოვნა"},
    headDeniedRewriteRequest: {id: 31, title: "უარი თქვა განაცხადის გადაწერის მოთხოვნაზე მოთხოვნა"},
    adminConfirmedRewriteRequest: {id: 32, title: "ადმინისტრატორმა დაადასტურა განაცხადის გადაწერა"},
    requeredMergeCase: {id: 33, title: "მოითხოვა განაცხადის გაერთიანება"},
    requerdToMoveCaseToObjectRegistery: {id: 34, title: "მოითხოვა განაცხადის გადატანა უწყებრივ რეესტრში"},
    denyToMoveCaseToObjectRegistery: {id: 35, title: "უარი თქვა ობიექტის უწყებრივ რეესტრში გადატანაზე"},
    requestToChangeObject: {id: 36, title: "ობიეტზე განხორციელებული ცვლილების შესახებ განცხადება"},
    signedTheDocument: {id: 37, title: "ხელი მოაწერა დოკუმენტს"},
    removeCaseFromRegistery: {id: 38, title: "წაშალა ობიექტი უწყებრივი რეესტრიდან"},
    requestToRemoveCaseFromRegistery: {id: 39, title: "მოთხოვა ობიექტის ამოღება უწყებრივი რეესტრიდან"},
    declineInternalFile: {id: 40, title: "უკან დააბრუნა შიდა დოკუმენტი"},
    Unexamined: {id: 41, title: "განაცხადი გახდა განუხილველი"},
    Overdue: {id: 42, title: "განაცხადი გახდა ვადაგადაცილებული"},
    makeCaseSecret: {id: 43, title: "მოითხოვა ნებართვის გასაიდუმლოება"},
    additionalDocs: {id: 44, title: "ატვირთა დამატებითი დოკუმენტაცია"},
}

export function findStatusTitleByIdForInternalUser(statusId) {
    for (const key in CaseNotificationEnum) {
        if (CaseNotificationEnum.hasOwnProperty(key)) {
            const status = CaseNotificationEnum[key];
            if (status.id === statusId) {
                return status.title;
            }
        }
    }
    return "";
}


export default CaseNotificationEnum
